import {Button} from '@ui/buttons/button';
import {Link, useNavigate} from 'react-router';
import {useEffect, useState} from 'react';
import imgUrl1 from './404-1.png';
import imgUrl2 from './404-2.png';
import {Helmet} from '@common/seo/helmet';
import {useSettings} from '@ui/settings/use-settings';

export function NotFoundPage() {
  const navigate = useNavigate();
  const [remainingSeconds, setRemainingSeconds] = useState(8);
  const {
    branding: {site_name},
  } = useSettings();

  useEffect(() => {
    const tickInterval = window.setInterval(() => {
      setRemainingSeconds(prev => (prev > 0 ? prev - 1 : 0));
    }, 1000);

    const redirectTimeout = window.setTimeout(() => {
      navigate('/tr', {replace: true});
    }, 8000);

    return () => {
      window.clearInterval(tickInterval);
      window.clearTimeout(redirectTimeout);
    };
  }, [navigate]);

  return (
    <>
      <Helmet>
        {/* @ts-ignore */}
        <title>Sayfa Bulunamadı (404) — {site_name}</title>
        <meta name="robots" content="noindex, follow" />
      </Helmet>
      <div className="flex flex-col-reverse items-center justify-center gap-64 px-16 py-96 md:gap-112 md:px-176 md:py-80 lg:flex-row lg:px-96 lg:py-96">
      <div className="relative w-full pb-48 lg:pb-0 xl:w-1/2 xl:pt-96">
        <div className="relative">
          <div className="absolute">
            <div className="relative z-10">
              <h1 className="my-8 text-3xl font-extrabold text-main">404</h1>
              <h2 className="my-8 text-2xl font-bold text-main">Sayfa Bulunamadı</h2>
              <p className="my-16 max-w-[560px] text-lg text-main">
                Aradığınız sayfa mevcut değil veya bağlantı adresi değişmiş olabilir.
              </p>
              <p className="mb-16 text-sm text-muted">
                {remainingSeconds} saniye sonra anasayfaya yönlendirileceksiniz.
              </p>
              <Button
                className="my-8"
                elementType={Link}
                size="lg"
                to="/tr"
                variant="flat"
                color="primary"
              >
                Anasayfaya Dön
              </Button>
            </div>
          </div>
          <div className="dark:opacity-5">
            <img src={imgUrl2 as any} alt="" />
          </div>
        </div>
      </div>
      <div className="dark:opacity-80">
        <img src={imgUrl1 as any} alt="" />
      </div>
    </div>
    </>
  );
}
